import { Component, Input, TemplateRef, inject } from "@angular/core";
import { compact } from "lodash-es";
import { ReportDesignerItemGroupVertical } from "../../report-design-item";
import { ReportFormRendererComponent } from "../report-form-renderer.component";

@Component({
  selector: "snt-report-form-renderer-group-vertical",
  templateUrl: "report-form-renderer-group-vertical.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererGroupVerticalComponent {
  @Input()
  item!: ReportDesignerItemGroupVertical;

  @Input()
  templateOutlet!: TemplateRef<any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  private readonly reportFormRenderer = inject(ReportFormRendererComponent);

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "group-vertical",
      config: {
        cols: this.item.config.cols,
        items: compact(
          await Promise.all(
            this.reportFormRenderer.renderers
              .toArray()
              .filter(
                (x) =>
                  x.level === this.level + 1 &&
                  x.parentName === this.item.config.name
              )
              .map((x) =>
                !!x.renderPdfObject
                  ? x.renderPdfObject()
                  : Promise.resolve(null)
              )
          )
        )
      }
    };
  }
}
